
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: { LogTable },
})
export default class KeyLogsTable extends Vue {

  @Prop({default: null})
  public currentKey: any;

  private logs = {
    rows: [],
    count: 0,
    types: [],
  };
  private loadingLogs: boolean = false;

  private getLogs(params?: any): void {
    if (this.currentKey?.id) {
      this.loadingLogs = true;
      Promise.all([
        this.$store.dispatch("logs/getLogs", {
          query: {
            currentPage: "key",
            entityId: this.currentKey.id,
            entityType: "key",
            ...params,
          },
        }),
        this.$store.dispatch("logs/getTypes", {
          query: {
            entityId: this.currentKey.id,
            entityType: "key",
          },
        }),
      ]).then(([resLogs, logsTypes]) => {
        this.logs.rows = resLogs.rows;
        this.logs.count = resLogs.count;
        this.logs.types = logsTypes.types;
      }).finally(() => {
        this.loadingLogs = false;
        this.$emit("loaded");
      });
    }
  }
}
